import { commonSbEnv } from "./env.sb.common";

const env: Partial<typeof commonSbEnv> = {
  production: true,
  page: 'imobiliare-nivelul-2',
  pageCode: 'sbn2',
  meta: {
    siteTitle: 'Stiința Banilor - curs de investiții imobiliare nivelul 2',
    ogSiteName: 'Stiința Banilor',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://stiintabanilor.ro/cursuri/curs-investitii-imobiliare-nivelul-2/',
    ogImage: 'https://stiintabanilor.ro/cursuri/curs-investitii-imobiliare-nivelul-2/assets/images/imobiliare-nivel-2/cover-fb.png'
  }
};

export const environment = { ...commonSbEnv, ...env };
